
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#50585B","stroke-width":"1.1","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M9.343 8.827a7.827 7.827 0 1115.654 0 7.827 7.827 0 01-15.654 0z"}}),_c('path',{attrs:{"d":"M15.083 10.388a1.566 1.566 0 101.566-1.565 1.566 1.566 0 111.565-1.566m-9.709 5.329v9.104m-1.712-2.951a1.566 1.566 0 101.565-1.565 1.566 1.566 0 111.566-1.566"}}),_c('path',{attrs:{"d":"M9.376 9.373A7.812 7.812 0 001 17.173 7.827 7.827 0 008.827 25a7.812 7.812 0 007.799-8.377m.098-12.313v9.104"}})])])
          )
        }
      }
    